import {TMcpScope} from '../../react-sdk/queries';

export const MCP_SCOPES: {value: TMcpScope; label: string; description: string; adminOnly: boolean}[] = [
  {value: 'read', label: 'Read', description: 'List and read templates, envelopes, contacts, and usage.', adminOnly: false},
  {
    value: 'templates:write',
    label: 'Edit templates',
    description: 'Create and edit templates, documents, roles, and fields.',
    adminOnly: false,
  },
  {value: 'envelopes:write', label: 'Send envelopes', description: 'Send, update, remind, and cancel envelopes.', adminOnly: false},
  {
    value: 'org:write',
    label: 'Organization',
    description: 'Organization details, brands, email domains, notification templates, contacts, and child organizations.',
    adminOnly: true,
  },
  {value: 'debug', label: 'Delivery logs', description: 'Webhook delivery history, with resend.', adminOnly: true},
  {
    value: 'destructive',
    label: 'Delete',
    description: 'Delete templates, documents, brands, and members.',
    adminOnly: false,
  },
];
